import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {AdsnUiType} from "@adsn/angular-ui";

@Component({
    selector: 'app-not-found',
    templateUrl: './page-error.component.html',
    styleUrls: ['./page-error.component.scss']
})
export class PageErrorComponent implements OnInit {

    state: any = null;

    constructor(private router: Router) {
    }

    ngOnInit(): void {
        this.state = history.state || null;
    }

    public refresh() {
        if (this.state) {
            this.router.navigate([this.state.url], {queryParams: this.state.queryParams});
        }
    }

    protected readonly AdsnUiType = AdsnUiType;
}
